/**
 * True only inside the RN WebView shell (file:// bundle).
 * Browser / PM2 deploy: always false — routing and redirects stay unchanged.
 */
export function isNativeWebView() {
  return (
    typeof window !== 'undefined' &&
    !!window.isNativeApp &&
    !!window.ReactNativeWebView
  );
}

/**
 * Full-page redirect safe for file:// + HashRouter (uses location.hash).
 * Use instead of window.location.href = '/path'.
 */
export function redirectTo(path) {
  if (!path) return;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (isNativeWebView()) {
    window.location.hash = normalized;
    return;
  }
  window.location.href = normalized;
}

/** href for plain <a> tags when not using React Router <Link>. */
export function appHref(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return isNativeWebView() ? `#${normalized}` : normalized;
}
